<template>

  <div class="wrap">
    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 头图 -->
    <div class="section-one banner-fix">
      <img src="../../img/product/banner.png" />

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span>给水产品系统
        </div>
        <!-- <img src="../../img/product/nav-top.png" class="product p-0" /> -->
      </div>

      <img src="../../img/product/title.png" class="v-c-title product-t" />
    </div>

    <ProductCard v-if="!isMobile" @open3d="open3d" />

    <div id="product-cards" v-else>
      <div 
        class="section-middle product-card"
        v-for="product in products"
        :key="product.id"
        :id='"p"+product.id'
        :name='"p"+product.id'
      >
        <div class="item">
          <img
            :src="product.pic"
            :alt="product.name + ' 应用场景'"
            class="zoomable"
            @click="open3d(product)"
          />
        </div>

        <div class="item download">
          <img
            :src="product.info"
            :alt="product.name + ' 产品卖点'"
            class="zoomable"
            @click="open3d(product)"
          />
          <a :href="product.url" class="link" target="_blank" rel="noopener">
            <img src="../../img/product/btn-down.png" alt="下载产品样册" />
          </a>
          <!-- <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E8%B4%9D%E7%91%9E%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a> -->
        </div>
      </div>

      <!-- <div class="section-middle product-card">
        <div class="item">
          <img src="../../img/product/p1-pic.jpg" />
        </div>

        <div class="item download">
          <img src="../../img/product/p1-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E8%B4%9D%E7%91%9E%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p1-pic.jpg" />
        </div>

        <div class="item ">
          <img src="../../img/product/p1-desc.jpg" />
        </div>
      </div>
      <div class="section-middle" id="p2" name="p2">
        <div class="item">
          <img src="../../img/product/p2-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p2-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%99%AE%E4%B9%90%E4%BB%95%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p2-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p2-desc.jpg" />
        </div>
      </div>
      <div class="section-middle" id="p3" name="p3">
        <div class="item">
          <img src="../../img/product/p3-pic.jpg" />
        </div>
        <div class="item">
          <img src="../../img/product/p3-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%A2%B5%E5%B0%94%E8%A5%BF_%E4%BC%8A%E8%80%90%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p3-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p3-desc.jpg" />
        </div>
      </div>
    
      <div class="section-middle" id="p4" name="p4">
        <div class="item">
          <img src="../../img/product/p4-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p4-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%B3%95%E6%96%AF%E7%89%B9%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p4-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p4-desc.jpg" />
        </div>
      </div>
      <div class="section-middle" id="p5" name="p5">
        <div class="item">
          <img src="../../img/product/p5-pic.jpg" />
        </div>
        <div class="item">
          <img src="../../img/product/p5-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E4%BD%8F%E5%AE%85%E7%BB%99%E6%B0%B4%E9%98%80%E9%97%A8%E7%B3%BB%E5%88%97.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p5-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p5-desc.jpg" />
        </div>
      </div>

      <div class="section-middle" id="p6" name="p6">
        <div class="item">
          <img src="../../img/product/p6-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p6-info.jpg" />
          <a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%E5%B7%A5%E7%A8%8B%E7%BB%99%E6%B0%B4%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C.pdf" class="link">
            <img src="../../img/product/btn-down.png" />
          </a>
        </div>
      </div>
      <div class="section-middle">
        <div class="item">
          <img src="../../img/product/p6-pic.jpg" />
        </div>

        <div class="item">
          <img src="../../img/product/p6-desc.jpg" />
        </div>
      </div> -->
    </div>

    <Model3D
      v-model="show3d"
      :model-key="cur.model"
      :title="cur.model3dTitle"
      :subtitle="cur.name"
    />

    <Footer />

  </div>

</template>

<script>
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
// import ProductCard from '../components/ProductCard.vue';
import ProductCard from '../components/ProductCard-v1.vue';
import { isMobileUA } from '../../util/device';
// import ProductCard from '../components/ProductCard.0913.vue';

// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  data() {
    return {
      isMobile: false,
      activeId: 1,
      show3d: false,
      cur: { model: 'press-fitting-copper', model3dTitle: '铜管压接接头', name: '' },
      products: [
        {
          id: 1,
          name: '贝瑞斯系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p1-pic.jpg'),
          info: require('@/img/product/v2/1.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E8%B4%9D%E7%91%9E%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf'
        },{
          id: 2,
          name: '普乐仕系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p2-pic.jpg'),
          info: require('@/img/product/v2/2.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%99%AE%E4%B9%90%E4%BB%95%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf'
        },{
          id: 3,
          name: '梵尔西/伊耐斯系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p3-pic.jpg'),
          info: require('@/img/product/v2/3.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%A2%B5%E5%B0%94%E8%A5%BF_%E4%BC%8A%E8%80%90%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf'
        },{
          id: 4,
          name: '法斯特系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p4-pic.jpg'),
          info: require('@/img/product/v2/4.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%B3%95%E6%96%AF%E7%89%B9%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf'
        },{
          id: 5,
          name: '住宅给水阀门系列',
          model: 'ball-valve',
          model3dTitle: '全通径黄铜球阀',
          pic: require('@/img/product/p5-pic.jpg'),
          info: require('@/img/product/v2/5.jpg'),
          url: 'https://book.yunzhan365.com/gzdv/wtwn/mobile/index.html'
          // url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E4%BD%8F%E5%AE%85%E7%BB%99%E6%B0%B4%E9%98%80%E9%97%A8%E7%B3%BB%E5%88%97.pdf'
        },{
          id: 6,
          name: '工程不锈钢系列',
          model: 'press-fitting',
          model3dTitle: '双卡压不锈钢管件',
          pic: require('@/img/product/p6-pic.jpg'),
          info: require('@/img/product/v2/6.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%E5%B7%A5%E7%A8%8B%E7%BB%99%E6%B0%B4%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C.pdf'
        }
      ]
    }
  },
  components: {
    Nav,
    Footer,
    ProductCard,
    // 异步加载：three.js 只在用户真的打开 3D 构建图时才下载
    Model3D: () => import('../../components/viewer3d/Model3D.vue')
  },
  mounted() {
    this.isMobile = isMobileUA()
    // gsap.registerPlugin(ScrollTrigger);

    // ScrollTrigger.create({
    //     trigger: '.banner-fix', //skyblue元素
    //     start: 'top top', //.skyblue元素的顶部开始  
    //     end: '+=5000',  // 到1600px结束
    //     markers: true, //开始标记  结束标记
    //     scrub: true,  // 关键点  和滚动条绑定
    //     pin: true,  //固定起始位置
    //     /**
    //      *  fromTo里第一个对象是开始的状态  第二个动画是你要执行的状态
    //      *  '<' 上一个动画开始，我也开始
    //      *  '>' 上一个动画结束，我在开始   默认
    //      *   1 一秒后执行  可以2也可以3....
    //      *  '+=1' 上一个动画结束后一秒我在执行   可以2也可以3....
    //      *  '-=1' 上一个动画结束前一秒我在执行    可以2也可以3....
    //     */
    //     // animation: gsap.timeline().fromTo('.pic1', { width: '20.8333rem', height: '33.3333rem' }, { width: '21.8333rem', height: '34.3333rem' }, '<')
    //     //     .fromTo('.pic2', { left: '50%' }, { left: '34%' }, '<')
    //     //     .fromTo('.pic3', { right: '50%' }, { right: '34%' }, '<')
    //     //     .fromTo('.pic4', { left: '50%' }, { left: '20%' }, '<')
    //     //     .fromTo('.pic5', { right: '50%' }, { right: '20%' }, '<')
    //     //     .fromTo('.pic6', { left: '50%' }, { left: '8%' }, '<')
    //     //     .fromTo('.pic7', { right: '50%' }, { right: '8%' }, '<')
    // })


    // this.$nextTick(()=> {
    //   this.goAnchor(window.location.hash)
    // })
  },
  methods: {
    open3d(product) {
      if (product) this.cur = product
      this.show3d = true
    }
    // goAnchor(selector) {
    //   let anchor = this.$el.querySelector(selector)
    //   document.documentElement.scrollTop = anchor.offsetTop 
    // }
  }
};
</script>

<style scoped lang="less">
.banner-fix {
  // width: 100%;
  // height: 100vh;
  // height: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: -1;
}
</style>